import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { StyledEngineProvider } from '@mui/material';
import { Provider } from 'react-redux';
import store from './redux/store';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>   
  {/* <React.StrictMode>      */}
    
    <StyledEngineProvider injectFirst>
    <BrowserRouter>   
        <App />    
    </BrowserRouter>       
    </StyledEngineProvider>
   
  {/* </React.StrictMode> */}
  </Provider>
);

